import { useEffect, useState } from 'react';
import { ContractService } from '../../../services/contract/contractService';

/*-----------------------------------------------------------------------------------------------------
* EN: Hook to manage contract expiration types fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de tipos de vencimiento de contrato.
-----------------------------------------------------------------------------------------------------*/

const useExpirationTypes = () => {

    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchExpirationTypes = async () => {
        setIsLoading(true);
        try {
            const service = new ContractService();
            const response = await service.getExpirationTypes();
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string, name: string, identifierLabel: string }) => ({
                    value: data.id,
                    label: data.name,
                    identifierLabel: data.identifierLabel,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching expiration types:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchExpirationTypes();
    }, []);

    const getExpirationTypesList = (entity?: string | null, notShowStatusID?: string | null) => {
        if (entity) return data.filter((state: any) => state.entity === entity);
        if (notShowStatusID) return data.filter((state: any) => state.value !== notShowStatusID);
        return data;
    };

    return { fetchExpirationTypes, getExpirationTypesList, isLoadingExpirationTypes: isLoading };
}

export default useExpirationTypes;